/* eslint-disable prefer-named-capture-group */
/* eslint-disable sort-keys */
import React from 'react'
import { ChevronDown } from 'react-feather'
import {
  validacaoSenha as passwordValidation,
  validacaoDataNascimento as birthDateValidation,
} from '../../utils/validadores/validadores'
import { formatDataNascimento } from '../../utils/formatter/formatter'
import { isEmptyObject } from '../../utils/helpers/helpers'

const genderDict = ( gender ) => {
  const result = {
    'No masculino': 'M',
    'No feminino': 'F',
    'Com qualquer uma das opções': 'Q',
    'Com nenhuma das opções': 'N',
  }[ gender ]
  return result ? result : ''
}

const whyDidSubscribedOptions = [
  'Selecione',
  'Criar o hábito da leitura',
  'Fortalecer o hábito da leitura',
  'Conhecer novos gêneros e autores',
  'Interesse em participar de um clube',
  'Receber um kit específico',
  'Brinde do plano',
  'Descontos',
  'Recomendação de influenciador',
  'Indicação de um amigo ou familiar',
  'Outros'
]

const whyDidSubscribedDict = ( whyDidSubscribed ) => {
  const result = {
    'Criar o hábito da leitura': 'CRIAR_HABITO',
    'Fortalecer o hábito da leitura': 'FORTALECER_HABITO',
    'Conhecer novos gêneros e autores': 'CONHECER_GENEROS_E_AUTORES',
    'Interesse em participar de um clube': 'INTERESSE_EM_CLUBE',
    'Receber um kit específico': 'KIT_ESPECIFICO',
    'Brinde do plano': 'BRINDE_DO_PLANO',
    'Descontos': 'DESCONTO',
    'Recomendação de influenciador': 'RECOMENDACAO_INFLUENCER',
    'Indicação de um amigo ou familiar': 'RECOMENDACAO_AMIGO',
    'Outros': 'OUTROS',
  }[ whyDidSubscribed ]
  return result ? result : ''
}


const defaultFormInputFields = () => ( {
  'gender': {
    'id': 'gender',
    'label': 'De que forma devemos nos referir a você?',
    'as': 'select',
    'required': true,
    'options': [ 'Selecione', 'No feminino', 'No masculino', 'Com qualquer uma das opções', 'Com nenhuma das opções' ].map( gender => ( {
      'value': genderDict( gender ),
      'text': gender
    } ) ),
    'data-testid': 'select-gender',
    'Icon': () => (
      <ChevronDown />
    )
  },
  'birthDate': {
    'helperText': '',
    'id': 'birthDate',
    'isValid': false,
    'label': 'Data de nascimento',
    'placeholder': 'dd/mm/aa',
    'value': '',
  },
  'whyDidSubscribed': {
    'id': 'whyDidSubscribed',
    'label': 'Por qual motivo você assinou a TAG?',
    'as': 'select',
    'required': true,
    'options': whyDidSubscribedOptions.map( whyDidSubscribed => ( {
      'value': whyDidSubscribedDict( whyDidSubscribed ),
      'text': whyDidSubscribed
    } ) ),
    'data-testid': 'select-why-did-subscribed',
    'Icon': () => (
      <ChevronDown />
    )
  },
  'password': {
    'helperText': '',
    'id': 'password',
    'isValid': false,
    'label': 'Escolha uma senha',
    'value': '',
    'type': 'password'
  },
  'passwordConfirmation': {
    'helperText': '',
    'id': 'passwordConfirmation',
    'isValid': false,
    'label': 'Confirme sua senha',
    'value': '',
    'type': 'password'
  },
} )

const formMask = ( inputId, inputValue ) => {
  const birthDateMask = value => (
    value
      .replace( /\D/gu, '' )
      .replace( /(\d{2})(\d)/u, '$1/$2' )
      .replace( /(\d{2})(\d)/u, '$1/$2' )
      .replace( /(\d{4})(\d)/u, '$1' )
      .substring( 0, 10 )
  )
  const passwordMask = ( value ) => value.replace( ' ', '' ).substring( 0, 100 )
  const masks = {
    'birthDate': birthDateMask,
    'password': passwordMask,
    'passwordConfirmation': passwordMask,
  }

  if ( inputId in masks ) {
    return masks[ inputId ]( inputValue )
  } else {
    return inputValue
  }
}

const genderValidation = ( gender ) => {
  const [ { 'text': genderFieldPlaceholder } ] = defaultFormInputFields().gender.options
  return Boolean( gender && ( gender !== genderFieldPlaceholder ) )
}

const whyDidSubscribedValidation = ( whyDidSubscribed ) => {
  const [ { 'text': whyDidSubscribedFieldPlaceholder } ] = defaultFormInputFields().whyDidSubscribed.options
  return Boolean( whyDidSubscribed && ( whyDidSubscribed !== whyDidSubscribedFieldPlaceholder ) )
}

const formValidate = ( inputId, inputValue ) => {
  const birthDateValidator = ( birthDate ) => {
    const result = birthDateValidation( birthDate )
    return result ? result : 'success'
  }

  const passwordValidator = ( password ) => {
    const result = passwordValidation( password )
    return result ? result : 'success'
  }

  const genderValidator = ( gender ) => {
    const isValidGender = genderValidation( gender )
    return isValidGender ? 'success' : 'Opção não selecionada'
  }

  const whyDidSubscribedValidator = ( whyDidSubscribed ) => {
    const isValidwhyDidSubscribed = whyDidSubscribedValidation( whyDidSubscribed )
    return isValidwhyDidSubscribed ? 'success' : 'Opção não selecionada'
  }

  const validators = {
    'birthDate': birthDateValidator,
    'password': passwordValidator,
    'gender': genderValidator,
    'whyDidSubscribed': whyDidSubscribedValidator,
  }

  if ( inputId in validators ) {
    const validationMessage = validators[ inputId ]( inputValue )
    if ( validationMessage === 'success' ) {
      return { 'helperText': '', 'isValid': true }
    }
    return { 'helperText': validationMessage, 'isValid': false }
  }

  return { 'helperText': '', 'isValid': true }
}

const prefillFormFields = ( dadosAssociado, updateFormFields ) => {
  if ( isEmptyObject( dadosAssociado ) ) {
    return
  }

  const fields = []

  if ( dadosAssociado.sexo ) {
    fields.push( { 'id': 'gender', 'value': dadosAssociado.sexo } )
  }
  if ( dadosAssociado.dtNascimento ) {
    fields.push( { 'id': 'birthDate', 'value': formatDataNascimento( dadosAssociado.dtNascimento, '-', '/' ) } )
  }
  if ( dadosAssociado.porqueAssinou ) {
    fields.push( { 'id': 'whyDidSubscribed', 'value': dadosAssociado.porqueAssinou } )
  }

  fields.forEach( ( { id, value } ) => updateFormFields( id, value, true, '' ) )
}

export { formValidate, genderDict, defaultFormInputFields, formMask, prefillFormFields }
